export const getRequestType = (type) => `${type}_REQUEST`;
export const getSuccessType = (type) => `${type}_SUCCESS`;
export const getErrorType = (type) => `${type}_ERROR`;
